import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";

import Player from "./components/player/player";

import autoBind from "react-autobind";

import { getCurrentItem } from "./utils/utils";
import { setNextItemChecked, gotoLinkYesNo, gotoLinkPicker, gotoNextItem, gotoPreviousItem } from "./actions/playerActions";

class Activity extends PureComponent {
	constructor(props) {
		super(props);

		autoBind(this);
	}

	keyHandling(e) {
		const itemModalVisible = this.context.tree.get(["appState","itemModalVisible"]);
		const showImagePreview = this.context.tree.get(["appState","showImagePreview"]);
		const showVideoPreview = this.context.tree.get(["appState","showVideoPreview"]);
		const logbookModalVisible = this.context.tree.get(["player", "logbookModalVisible"]);
		const sketchPadShow = this.context.tree.get(["player", "sketchPad", "show"]);
		const promptModalMoveForwardVisible = this.context.tree.get(["player", "promptModalMoveForwardVisible"]);
		const showBarcodeScanner = this.context.tree.get(["player", "showBarcodeScanner"]);
		const showNavigationView = this.context.tree.get(["player", "showNavigationView"]);
		const showComments = this.context.tree.get(["player", "showComments"]);

		// If any modals are up return immediately
		// Could support actions for some modals
		if (
			itemModalVisible || 
			showImagePreview || 
			showVideoPreview || 
			logbookModalVisible || 
			sketchPadShow || 
			promptModalMoveForwardVisible || 
			showBarcodeScanner || 
			showNavigationView || 
			showComments
			) {
			
			return;
		}

		if (e.code === "ArrowUp") {
			gotoPreviousItem(this.context.tree);
			return;
		} else if (e.code === "ArrowDown") {
			gotoNextItem(this.context.tree);
			return;
		}

		const item = getCurrentItem();

		switch (item.type) {
			case "itemPicker": {
				if (e.code === "ArrowRight") {
					gotoLinkPicker(this.context.tree, 0);
				} else if (e.code === "ArrowLeft") {
					gotoLinkPicker(this.context.tree, 1);
				}
				break;
			}
			case "itemYesNo": {
				if (e.code === "ArrowRight") {
					gotoLinkYesNo(this.context.tree, "yes");
				} else if (e.code === "ArrowLeft") {
					gotoLinkYesNo(this.context.tree, "no");
				}
				break;
			}
			default: {
				if (e.code === "ArrowRight") {
					setNextItemChecked(this.context.tree);
				}
			}	
		}
	}

	componentDidMount() {
		window.addEventListener("keyup", this.keyHandling);
	}

	componentWillUnmount() {
		window.removeEventListener("keyup", this.keyHandling);
	}
	
	render() {
		return (
			<div className="ambifi-web-player">
				<Player />
				{/* <pre>{JSON.stringify(this.props.activity,null,3)}</pre> */}
			</div>
		);
	}
}

Activity.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	activity: ["activity"]
}, Activity);
